import {
  buildCartFragment,
  updateShippingMessage,
  updateWholeSale,
  checkIfHeaderCartWasEmpty,
  getCart,
  postCartAdd,
} from '../utils/cart-tools';

import '../../styles/product-grid-item.scss';

[...document.querySelectorAll('.quickbuy-collection-wrapper')]
  .forEach(wrapper => {
    if (wrapper) {
      wrapper
      .addEventListener('click', (e) => {
        const { target } = e;

        if (target.classList.contains('quickbuy__button')) {
          const id = target.value;
          const quantity = 1;
          const initialInnerText = target.innerText;
          const cartCounts = document.querySelectorAll('.cart-count');
          const cartSubtotals = document.querySelectorAll('.cart-subtotal');

          e.preventDefault();
          postCartAdd({ id, quantity })
            .then(() => {
              target.innerText = 'adding…';
              getCart()
                .then((resData) => {
                  const bags = document.querySelectorAll('.cart-nav');

                  target.innerText = initialInnerText;
                  [...cartCounts].forEach(el => el.innerHTML = resData.item_count);

                  if (document.querySelector('.cart-items-scroll')) {
                    document.querySelector('.cart-items-scroll').innerHTML = buildCartFragment({ resData });
                  }

                  checkIfHeaderCartWasEmpty({ resData });
                  [...cartSubtotals].forEach(el => el.innerHTML = `$${resData.total_price / 100}`);

                  updateWholeSale({ resData });

                  [...document.querySelectorAll('[ data-cart-shipping-message]')].forEach(shipping => {
                    if (shipping) {
                      shipping.innerHTML = updateShippingMessage({ resData });
                    }
                  });

                  [...bags].forEach(bag => bag.classList.add('addingToCart'));
                  setTimeout(() => {
                    [...bags].forEach(bag => bag.classList.remove('addingToCart'));
                  }, 1500);
                });
            });
        }
      });
    }
  });
